import { render, staticRenderFns } from "./MarketplaceTable.vue?vue&type=template&id=cefcdd5c&"
import script from "./MarketplaceTable.vue?vue&type=script&lang=js&"
export * from "./MarketplaceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports